import fallback from './locales/en.json'
import { registerGroup, $t as sharedT } from '@/i18n'

const GROUP = 'navbar'

registerGroup(GROUP, fallback)

export { getLocale, getRawLocale, setLocale, localized } from '@/i18n'

export function $t(key: string): string {
  return sharedT(GROUP, key)
}
